"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = require("../../../shared");
var isElementFocusable_1 = require("../../../shared/isElementFocusable");
var ModalHelper = /** @class */ (function () {
    function ModalHelper() {
    }
    Object.defineProperty(ModalHelper, "count", {
        get: function () {
            return ModalHelper.modals.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModalHelper, "activeModal", {
        get: function () {
            if (ModalHelper.count > 0) {
                return (ModalHelper.modals[ModalHelper.count - 1]);
            }
        },
        enumerable: true,
        configurable: true
    });
    ModalHelper.init = function () {
        if (!ModalHelper.globalEventsBound) {
            ModalHelper.document.addEventListener('keyup', ModalHelper.handleEscape);
            ModalHelper.document.addEventListener('focus', ModalHelper.trapFocus, true);
            ModalHelper.globalEventsBound = true;
        }
    };
    ModalHelper.addActiveModal = function (modal) {
        ModalHelper.modals.push(modal);
        setTimeout(function () {
            if (modal.modalNode) {
                ModalHelper.focusFirstDescendant(modal.modalNode);
            }
        }, 10);
    };
    ModalHelper.removeActiveModal = function (modal) {
        if (ModalHelper.isActiveModal(modal)) {
            ModalHelper.modals.pop();
            if (ModalHelper.count > 0 &&
                ModalHelper.activeModal &&
                ModalHelper.activeModal.modalNode) {
                ModalHelper.focusFirstDescendant(ModalHelper.activeModal.modalNode);
            }
        }
    };
    ModalHelper.focusFirstDescendant = function (node) {
        if (node) {
            for (var _i = 0, _a = Array.from(node.childNodes); _i < _a.length; _i++) {
                var child = _a[_i];
                if (ModalHelper.attemptFocus(child) ||
                    ModalHelper.focusFirstDescendant(child)) {
                    return true;
                }
            }
        }
        return false;
    };
    Object.defineProperty(ModalHelper, "document", {
        get: function () {
            return document;
        },
        enumerable: true,
        configurable: true
    });
    ModalHelper.isActiveModal = function (modal) {
        return modal === ModalHelper.activeModal;
    };
    ModalHelper.attemptFocus = function (node) {
        if (!isElementFocusable_1.isElementFocusable(node)) {
            return false;
        }
        ModalHelper.IgnoreUtilFocusChanges = true;
        try {
            node.focus();
        }
        catch (e) {
            console.error(e.message);
        }
        ModalHelper.IgnoreUtilFocusChanges = false;
        return this.document.activeElement === node;
    };
    ModalHelper.closeActiveModal = function () {
        if (ModalHelper.activeModal) {
            ModalHelper.activeModal.handleClose();
            return true;
        }
        return false;
    };
    ModalHelper.focusLastDescendant = function (node) {
        if (node) {
            for (var _i = 0, _a = Array.from(node.childNodes).reverse(); _i < _a.length; _i++) {
                var child = _a[_i];
                if (ModalHelper.attemptFocus(child) ||
                    ModalHelper.focusLastDescendant(child)) {
                    return true;
                }
            }
        }
        return false;
    };
    ModalHelper.globalEventsBound = false;
    ModalHelper.modals = [];
    ModalHelper.IgnoreUtilFocusChanges = false;
    ModalHelper.trapFocus = function (event) {
        if (ModalHelper.IgnoreUtilFocusChanges) {
            return;
        }
        var activeModal = ModalHelper.activeModal;
        if (activeModal) {
            var eventElement = event.target;
            if (activeModal.modalNode) {
                if (activeModal.modalNode.contains(eventElement)) {
                    activeModal.lastFocus = eventElement;
                }
                else {
                    ModalHelper.focusFirstDescendant(activeModal.modalNode);
                    if (activeModal.lastFocus ===
                        ModalHelper.document.activeElement) {
                        ModalHelper.focusLastDescendant(activeModal.modalNode);
                    }
                    activeModal.lastFocus = ModalHelper.document.activeElement;
                }
            }
        }
    };
    ModalHelper.handleEscape = function (event) {
        var key = event.key;
        if (key === shared_1.KEYS.ESCAPE && ModalHelper.closeActiveModal()) {
            event.stopPropagation();
        }
    };
    return ModalHelper;
}());
exports.ModalHelper = ModalHelper;
